import React, { useState, useEffect } from "react";
import { navigate } from "gatsby";

import { linkTo } from "../Link";
import ArticleCardContainer from "../ArticleCardContainer";
import Filtration from "./LearnArticleFiltration";
import useDebounce from "../../hooks/useDebounce";
import { normalizeLevel } from "../../utils";

export const LIMIT = 6;
export const defaultSelectedLevel = {
  beginner: true,
  intermediate: true,
  advanced: true,
};

const LearnOurArticles = ({ t, lang, posts, categories }) => {
  const [filteredPosts, setFilteredPosts] = useState(posts.slice(0, LIMIT));

  const transformCategoriesData = categories.reduce(
    (result, cat) => ({
      ...result,
      [cat.slug]: {
        isActive: true,
        isMain: cat.acfCategories?.catShowOnFilter === "1",
      },
    }),
    {}
  );

  const [selectedCategories, setSelectedCategories] = useState(
    transformCategoriesData
  );

  const [selectedLevel, setSelectedLevel] = useState(defaultSelectedLevel);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  useEffect(() => {
    const _applyFilters = () => {
      const filtered = posts.filter((post) => {
        const foundCats = post.categories.nodes.find(
          (cat) =>
            /articles/.test(cat.wpParent?.node.slug) &&
            selectedCategories[cat.slug].isActive
        );
        const foundTag = post.tags.nodes.find(
          (tag) => selectedLevel[normalizeLevel(tag.slug)]
        );

        const foundTitle = debouncedSearchTerm
          ? post.title.search(new RegExp(debouncedSearchTerm, "i")) >= 0
          : true;

        return foundCats && foundTag && foundTitle;
      });

      setFilteredPosts(filtered.slice(0, LIMIT));
    };

    _applyFilters();
  }, [posts, selectedCategories, selectedLevel, debouncedSearchTerm]);

  const _navigateToFiltration = () => {
    const cats = Object.keys(selectedCategories)
      .filter((key) => selectedCategories[key].isActive)
      .join(",");
    navigate(linkTo(lang, `/learn/filtration/?topic=articles&cat=${cats}`));
  };

  return (
    <>
      {filteredPosts && (
        <div id="our-articles" className="our-articles">
          <div className="mb-5 page-content">
            <div className="container">
              <Filtration
                categories={selectedCategories}
                setSelectedCategories={setSelectedCategories}
                selectedLevel={selectedLevel}
                setSelectedLevel={setSelectedLevel}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />

              <ArticleCardContainer
                posts={filteredPosts}
                topics={["articles"]}
                linkText={t("common.learnMore")}
              />

              <div className="row justify-content-center">
                <button
                  className="button button-secondary button-buy text-center mt-4"
                  type="button"
                  onClick={() => {
                    _navigateToFiltration();
                  }}
                >
                  {t("learn.articles.btnSeeMore")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LearnOurArticles;
